import {CentroDiCostoRecord} from "./CentroDiCostoRecord";
import {ObjectFactory} from "@commons/types";
import {SaldoICRecord} from "@commons/mapping/SaldoICRecord";
import {merge} from "lodash";

export type FlagIC = 'TE' | 'INC' | 'CONTR' | 'RES_AP' | 'MAT' | 'GOD' | 'RES_MESE' | 'RES_ANNO' | 'ATT_P' | 'ATT_WF';

export interface IstitutoContrattualeRecord extends CentroDiCostoRecord {
    codIstituto: string | null,	// es. "FR"
    showFlags: string[],
    saldo: SaldoICRecord | null,
}

export class IstitutoContrattualeRecord {
    static factory: ObjectFactory<IstitutoContrattualeRecord> = (json?) => {
        return merge<IstitutoContrattualeRecord, Partial<IstitutoContrattualeRecord> | undefined>({
            idAzienda: 0,
            idTipo: 15,
            codIstituto: null,
            id: (json && json.codIstituto) ? json.codIstituto : null,
            descrizione: null,
            descrizione2: null,
            showFlags: [],
            saldo: null,
            altro1: null,
            altro2: null,
            altro3: null,
            altro4: null,
            altro5: null,
            altro6: null,
            altro7: null,
            livelloEdit: null,
            countGiustificativi: null,
            countCDICRelazionati: null,
            colore: null,
            giustificativi: [],
            statusGiustificativi: [],
            URI: null,
            validitaInizio: null,
            validitaFine: null,
        }, json);
    }

    // Il campo generico "altro4" (tipo string) rappresenta l'elenco dei campi da visualizzare nel riepilogo ferie per l'utente finales
    // eseguo split della stringa "altro4" "TE;MAT;GOD;RES_MESE;RES_ANNO" in ['TE','MAT','GOD','RES_MESE','RES_ANNO']
    static getFieldList = (istitutoContrattuale: IstitutoContrattualeRecord): FlagIC[] => {
        return (istitutoContrattuale.altro4 ? istitutoContrattuale.altro4.split(";") : []) as FlagIC[];
    }
}
